import { useMemo } from 'react';
import { trpcAdmin } from '@duke-hq/app-admin-web/lib/trpcAdmin';
import { courseHasPendingTranslation, TRANSLATION_POLL_INTERVAL_MS } from './coverageStatus';
import { summariseCoverage, type TranslationsToolbarSummary } from './translationsSummary';

// The unit equivalent of useCourseTranslations. A unit has no configured
// language set of its own (it's shared across courses), so listByUnit measures
// coverage against every translatable language. "Active" therefore can't hinge
// on a configured set the way the course pill does; it means the unit has at
// least one published resource worth showing a pill for.
export function useUnitTranslations(unitId: string): TranslationsToolbarSummary {
  const query = trpcAdmin.contentTranslations.listByUnit.useQuery(
    { unitId },
    {
      refetchInterval: (query) =>
        courseHasPendingTranslation(query.state.data?.units) || query.state.status === 'error'
          ? TRANSLATION_POLL_INTERVAL_MS
          : false,
      refetchIntervalInBackground: true,
    },
  );

  const summary = useMemo(
    () =>
      summariseCoverage(
        query.data?.units ?? [],
        query.data?.supportedLanguages ?? [],
        query.isError,
      ),
    [query.data, query.isError],
  );

  const isActive = summary.total > 0;

  return { ...summary, isLoading: query.isLoading, isError: query.isError, isActive };
}
